export const containsExactString = (substring: string, mainString: string) => {
  const regex = new RegExp(`(^|[._])${substring}([._]|$)`);
  return regex.test(mainString);
};

export function transliterateFromCyrillic(
  text: string,
  addSpace = false,
): string {
  const cyrillicArr = [
    "-",
    "'",
    "а",
    "б",
    "в",
    "г",
    "ґ",
    "д",
    "е",
    "є",
    "ж",
    "з",
    "и",
    "і",
    "ї",
    "й",
    "к",
    "л",
    "м",
    "н",
    "о",
    "п",
    "р",
    "с",
    "т",
    "у",
    "ф",
    "х",
    "ц",
    "ч",
    "ш",
    "щ",
    "ь",
    "ю",
    "я",
    "А",
    "Б",
    "В",
    "Г",
    "Ґ",
    "Д",
    "Е",
    "Є",
    "Ж",
    "З",
    "И",
    "І",
    "Ї",
    "Й",
    "К",
    "Л",
    "М",
    "Н",
    "О",
    "П",
    "Р",
    "С",
    "Т",
    "У",
    "Ф",
    "Х",
    "Ц",
    "Ч",
    "Ш",
    "Щ",
    "Ю",
    "Я",
  ];
  const latinArr = [
    "-",
    "",
    "a",
    "b",
    "v",
    "h",
    "g",
    "d",
    "e",
    "ie",
    "zh",
    "z",
    "y",
    "i",
    "i",
    "i",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "r",
    "s",
    "t",
    "u",
    "f",
    "kh",
    "ts",
    "ch",
    "sh",
    "shch",
    "",
    "iu",
    "ia",
    "A",
    "B",
    "V",
    "H",
    "G",
    "D",
    "E",
    "Ye",
    "Zh",
    "Z",
    "Y",
    "I",
    "Yi",
    "Y",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "R",
    "S",
    "T",
    "U",
    "F",
    "Kh",
    "Ts",
    "Ch",
    "Sh",
    "Shch",
    "Yu",
    "Ya",
  ];

  const map: Record<string, string> = Object.fromEntries(
    cyrillicArr.map((c, i) => [c, latinArr[i]]),
  );

  return text
    .split(" ")
    .map((word) =>
      word
        .split("")
        .map((char, i) => {
          const isUpper = char === char.toUpperCase();
          const isAllCaps = word === word.toUpperCase();
          let latin = map[char] ?? "";
          if (isAllCaps) latin = latin.toUpperCase();
          else if (isUpper && latin.length > 1)
            latin = latin[0].toUpperCase() + latin.slice(1);
          return latin;
        })
        .join(""),
    )
    .join(addSpace ? " " : "");
}
export const parseIdentCode = (identCode: string): string | null => {
  if (identCode.length !== 10) return null;
  if (!/^\d+$/.test(identCode)) return null;

  const digits = identCode.split("").map(Number);
  const weights = [-1, 5, 7, 9, 4, 6, 10, 5, 7];
  const checksum = digits.slice(0, 9).reduce((sum, digit, i) => {
    return sum + digit * weights[i];
  }, 0);
  const controlNumber = (checksum % 11) % 10;

  if (controlNumber !== digits[9]) {
    return null;
  }
  const birthDaysSince1900 = parseInt(identCode.slice(0, 5), 10);
  const birthDate = new Date(1900, 0, 1);
  birthDate.setDate(birthDate.getDate() + birthDaysSince1900);

  if (isNaN(birthDate.getTime())) {
    return null;
  }

  return birthDate.toISOString().split("T")[0];
};
